import { ApiError } from './apiError.js';
import { DataLoadError } from './dataLoadError.js';

export function apiErrorMessage(error: unknown): string {
	if (error instanceof DataLoadError)
		return [...new Set(error.failures.map(apiErrorMessage))].join('. ');
	if (error instanceof ApiError) {
		if (error.kind === 'parse') return 'The service returned an unreadable response';
		if (error.kind === 'aborted') return 'Request cancelled';
		if (error.kind === 'network') return 'Service unreachable';
		const messages: Record<number, string> = {
			401: 'Your session expired; reload to sign in again',
			403: 'Not permitted',
			404: 'Not found',
		};
		return (
			messages[error.status] ??
			(error.detail || error.errors?.join('; ') || error.title || error.message || 'Request failed')
		);
	}
	return error instanceof Error ? error.message : 'Unable to load data';
}

export function isUnauthorized(error: unknown): boolean {
	return error instanceof ApiError
		? error.status === 401
		: error instanceof DataLoadError && error.failures.some(isUnauthorized);
}
